/** @format */

const dashboard = {
    express: '/assets/images/svg/dashboard/express.svg#svg-express-id',
    recruitment: '/assets/images/svg/dashboard/recrutement.svg#svg-recrutement-id',
    campaign: '/assets/images/svg/dashboard/developpement.svg#svg-developpement-id',
    assessment: '/assets/images/svg/dashboard/assessment.svg#svg-assessment-id',
    participant: '/assets/images/svg/dashboard/participant.svg#svg-participant-id',
    invite: "/assets/images/svg/dashboard/invite.svg",
    campagne: '/assets/images/svg/dashboard/campagne.svg',
    legendPurple: '/assets/images/svg/dashboard/legende-purple.png',
    legendRed: '/assets/images/svg/dashboard/legende-red.png',
    legendCirclePurple: '/assets/images/svg/dashboard/legend-circle-purple.svg',
    legendDiamondRed: '/assets/images/svg/dashboard/legend-diamond-red.svg',
    legendDiamondGreen: '/assets/images/svg/dashboard/legend-diamond-green.svg',
    team: '/assets/images/svg/dashboard/team.svg',
    smart_interview: '/assets/images/svg/tir/icon-smart.svg',
    catalog: '/assets/images/svg/tir/icon-catalog.svg',
    company: '/assets/images/svg/dashboard/company.svg#svg-company-id',
    users: '/assets/images/svg/dashboard/users.svg#svg-users-id',
    news: '/assets/images/svg/dashboard/news.svg#svg-news-id',
    directory: '/assets/images/svg/dashboard/directories-pack.svg',
    credit:  '/assets/images/svg/dashboard/credit.svg',
    subscriptionPro:  '/assets/images/svg/dashboard/subscription-pro.svg',
}

export default dashboard
